// core
import {
  Component, OnInit, Input, Inject
} from '@angular/core';
import { FormGroup } from '@angular/forms';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

// services
import { RaptorStepService } from '@campfire-nx/raptor/lib/services/raptor-step.service';
import { RaptorAnalyticsService } from '@campfire-nx/raptor/lib/services/raptor-analytics.service';
import { RaptorStepDataService } from '@campfire-nx/raptor/lib/services/raptor-step-data.service';
import { RaptorDataService } from '@campfire-nx/raptor/lib/services/raptor-data.service';
import { RaptorFormService } from '@campfire-nx/raptor/lib/services/raptor-form.service';

@Component({
  selector: 'open-raptor-page-covers',
  templateUrl: './raptor-page-covers.component.html',
  styleUrls: ['./raptor-page-covers.component.scss']
})
export class RaptorPageCoversComponent implements OnInit {
  @Input() formData: any;
  @Input() form!: FormGroup;

  layoutSettings: any = {};
  bannerHeaders!: any;
  frequencySwitch!: any;
  coverControl: any;
  disclaimers?: Array<any>;
  currency!: string;

  constructor(
    public raptorStepService: RaptorStepService,
    private raptorAnalyticsService: RaptorAnalyticsService,
    private raptorStepDataService: RaptorStepDataService,
    private raptorDataService: RaptorDataService,
    public raptorFormService: RaptorFormService,
    private partnerBrandService: PartnerBrandService,
    @Inject('environment') private environment: any
  ) { }

  ngOnInit(): void {
    this.layoutSettings = this.formData.settings || {};
    this.coverControl = this.form.get('cover_level');
    this.currency = this.partnerBrandService.getCurrencySymbol();

    this.formData.sections.forEach((section: any) => {
      section.elements.forEach((question: any) => {
        if (question.key === 'frequency') {
          this.frequencySwitch = question;
        }
      });
    });
    this.getBanners();
  }

  selectCover(cover: any) {
    // NOTE: this is a hack for now!!!
    this.coverControl.setValue(cover.cover.cover_level, { emitEvent: true });
    setTimeout(() => {
      const form = document.getElementById('coverSubmit');
      form?.click();
    }, 500);
  }

  getCoverPrice(cover: any): any {
    const formData = this.raptorStepDataService.get();
    const formValues = this.form.value;
    const price = {
      currency: this.currency,
      amount: 0,
      frequency: 'year'
    };

    const frequency = formValues.frequency || formData.data.frequency;
    let premiumAttr = 'payable';

    if (frequency === 'U') {
      price.frequency = 'year';
      premiumAttr = 'payable';
    }
    if (frequency === 'M') {
      price.frequency = 'month';
      premiumAttr = 'payable_monthly';
    }
    if (this.layoutSettings.premium_attribute === 'payable') {
      price.frequency = 'year';
      premiumAttr = 'payable';
    }
    price.amount = cover.premium[frequency] && cover.premium[frequency][premiumAttr];
    if (
      this.layoutSettings &&
      this.layoutSettings.precision === 'round_up'
    ) {
      price.amount = Math.ceil(price.amount);
    }

    return price;
  }

  getBanners() {
    this.disclaimers = this.raptorDataService.mapBannerDisclaimers(this.formData.covers);

    if (this.formData.banners?.length) {
      this.formData.bannerHeaders = this.formData.banners.filter((banner: any) => banner.type === 'header');
      this.formData.bannerHeaders.forEach((banner: any) => this.disclaimers?.push({ type: 'banner', content: banner.disclaimer }));
    }
  }

  getTagLabel(banner: any) {
    return this.raptorDataService.mapBannerTag(banner, this.disclaimers);
  }

  canEstimateSumInsured() {
    if ((this.formData.data.cover_type === 'home' ||
      this.formData.data.cover_type === 'landlords') &&
      (this.formData.data.has_address_construction_details === false)) {
      return false;
    }
    return true;
  }

  openPdsDocument(url: string) {
    this.raptorAnalyticsService.trackAdditionalEvents('select-option', 'pds');
    window.open(`${this.environment.apiEndpoint}${url}`, '_blank');
  }
}
